DEF.layout = DEF.layout || {};

DEF.RootLayout = Backbone.Marionette.View.extend({
	el: 'body',
	regions: {
		main: '#MAIN',
	}
});
